import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { 
  Spinner, NonIdealState
} from "@blueprintjs/core";
import Card from 'components/Card';
import { observer, inject } from 'mobx-react';
import InvoicesTable from 'components/Tables/Invoices';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const CardHolder = styled('div')`
padding: ${props => `${props.theme.unit*3}px`};
`
const PageWrapGray = styled('div')`
  padding: 8px 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'invoiceStore') @observer
class InvoicesIndexPage extends Component {

  render() {
    let content;
    let {
      invoiceStore: {
        invoices: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = <CardHolder><Spinner/></CardHolder>;
    }
    if (isError && !isLoading) {
      content = <NonIdealState title="Failed" description="Sorry, something went wrong" />;
    }
    if (!isError && !isLoading) {
      content = <InvoicesTable />
    }
    return (
      <div>
        <Helmet>
          <title>Invoices | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>          
            <SearchBars.Invoice />         
        </Sticky>
          <Card>
            {content}
          </Card>
        </PageWrapGray>
      </div>
    )
  }
  

};

export default InvoicesIndexPage;